// extracted by mini-css-extract-plugin
export default {"modalContainer":"ct","fadeRight":"et","fadeUp":"ft","topShelf":"gt","newFlavorBadge":"ht","transparentText":"it","cancelButton":"jt","invisibleLink":"kt","closeIcon":"lt","linkContainer":"mt","hed":"nt","image":"ot"};
    if(module.hot) {
      // 1715091669575
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  